import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

declare global {
  interface Window {
    HubSpotConversations?: {
      widget?: {
        refresh: () => void
      }
    }
  }
}

export const useHubSpotChatRefresh = () => {
  const location = useLocation()

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (window.HubSpotConversations?.widget?.refresh) {
      window.HubSpotConversations.widget.refresh()
    }
  }, [location.pathname])
}
